import './content.css'
import {Suspense} from "react";
import {RouterProvider,} from "react-router";
import APP_ROUTER from "../../../routes.tsx";

function Content() {
    return (
        <div className="content">
            <Suspense
                fallback={
                    <div
                        className="content-loading"
                        role="status"
                        aria-label="Inhalt wird geladen"
                    />
                }
            >
                <RouterProvider router={APP_ROUTER} />
            </Suspense>
        </div>
    )
}

export default Content
